import { Controller } from "@hotwired/stimulus"

// Preserve Piano Home's existing thank-you conversion (GTM-K6Q9BN3, tag 25).
export default class extends Controller {
  connect() {
    if (window.location.hostname !== "lophocdan.com") return
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.element.dataset.conversionSent === "true") return
    if (typeof window.gtag !== "function") return

    window.gtag("event", "conversion", {
      send_to: "AW-687972822/nrZkCPyH364DENbDhsgC"
    })
    this.element.dataset.conversionSent = "true"
  }
}
